// Drl Popup with
const drlPopup = document.getElementById('drl-popup');

if (drlPopup !== null) {
	const getSavedCookie = Cookies.get('popup_closed'); // => 'value'

	if (getSavedCookie !== 'popupClosed') {
		drlPopup.classList.add('open');

		const drlPopupClose = document.getElementById('close-popup');
		if (drlPopupClose) {
			drlPopupClose.addEventListener('click', function (e) {
				e.preventDefault();
				drlPopup.classList.remove('open');
				Cookies.set('popup_closed', 'popupClosed', {expires: 5});
			});
		}
	}
}
